module.exports = __webpack_public_path__ + "static/media/ic_attention.6fae2a78.png";